import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-border py-12 bg-white">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-shuttlebee-yellow rounded-lg flex items-center justify-center">
              <svg viewBox="0 0 24 24" className="w-5 h-5 text-shuttlebee-dark" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
              </svg>
            </div>
            <span className="font-display font-bold">Shuttlebee</span>
          </div>

          <div className="flex gap-6 text-sm text-muted-foreground">
            <Link to="/routes" className="hover:text-foreground transition-colors">
              Routes
            </Link>
            <Link to="/shuttle-info" className="hover:text-foreground transition-colors">
              Shuttle Info
            </Link>
            <Link to="/certified-drivers" className="hover:text-foreground transition-colors">
              Safety & Drivers
            </Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">
              Contact
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>

          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Shuttlebee. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
